<template lang="pug">
.container
    .info
        span width:{{width}}
        span height:{{height}}
</template>

<script>
export default {
    name: 'debug-view',
    data(){
        return{
            width: 100,
            height: 100
        }
    },
    mounted(){
        window.onresize = ()=>{
            this.onResize()
        }
        this.onResize()
    },
    methods:{
        onResize(){
            this.width = window.innerWidth,
            this.height= window.innerHeight
        }
    }
}
</script>

<style scoped lang="sass">
.container
    color: red
    font-size: 10px
    position: absolute
    top: 0
    right: 0
    width: 120px
    height: 120px
    background-color: orange


</style>